const createLoadedImage = (imageSrc) => new Promise((resolve) => {
    const image = document.createElement("img");
    image.addEventListener("load", () => resolve(image), { once: true });
    image.src = imageSrc;
});
const makeReactive = (object) => {
    const reactiveObject = {};
    Object.keys(object).forEach((key) => {
        Object.defineProperty(reactiveObject, key, {
            get() {
                return object[key];
            },
            set(value) {
                if (value == object[key]) {
                    return;
                }
                requestAnimationFrame(FaviconOverlayManager.render);
                return (object[key] = value);
            },
        });
    });
    return reactiveObject;
};
class FaviconOverlay {
    constructor(image) {
        this._position = makeReactive({
            x: 0,
            y: 0,
            centered: false,
        });
        this.image = image;
    }
    get position() {
        return this._position;
    }
    set position(value) {
        Object.assign(this._position, value);
    }
}
export class FaviconOverlayManager {
    constructor(image) {
        this.image = image;
        throw new Error("THIS BLOWS UP! DONT DO IT!");
    }
    static setFaviconOverlay(imageUrl) {
        return createLoadedImage(imageUrl).then((overlayImage) => {
            FaviconOverlayManager.overlays = [new FaviconOverlay(overlayImage)];
            requestAnimationFrame(FaviconOverlayManager.render);
        });
    }
    static resetFaviconOverlay() {
        FaviconOverlayManager.overlays = [];
        requestAnimationFrame(FaviconOverlayManager.render);
    }
    static get isInitialized() {
        return Boolean(FaviconOverlayManager.canvas);
    }
    static get faviconUrl() {
        const { faviconElement } = FaviconOverlayManager;
        const url = faviconElement.dataset.originalHref;
        if (url) {
            return url;
        }
        return (faviconElement.dataset.originalHref = faviconElement.href);
    }
    static getOverlay(idx) {
        return FaviconOverlayManager.overlays[idx];
    }
    static initialize({ faviconSelector = 'link[rel="icon"]', } = {}) {
        if (FaviconOverlayManager.isInitialized) {
            return Promise.resolve();
        }
        FaviconOverlayManager.canvas = document.createElement("canvas");
        FaviconOverlayManager.faviconElement = document.querySelector(faviconSelector);
        return createLoadedImage(FaviconOverlayManager.faviconUrl).then((image) => {
            FaviconOverlayManager.canvas.width = image.width;
            FaviconOverlayManager.canvas.height = image.height;
            FaviconOverlayManager.faviconImage = image;
        });
    }
    static render() {
        const { overlays, faviconImage, faviconElement, canvas, } = FaviconOverlayManager;
        if (!overlays.length) {
            faviconElement.href = faviconElement.dataset.originalHref;
            return;
        }
        const context = canvas.getContext("2d");
        context.clearRect(0, 0, faviconImage.width, faviconImage.height);
        context.drawImage(faviconImage, 0, 0, faviconImage.width, faviconImage.height, 0, 0, faviconImage.width, faviconImage.height);
        overlays.forEach((overlay) => {
            let { x, y } = overlay.position;
            if (overlay.position.centered) {
                x -= overlay.image.width / 2;
                y -= overlay.image.height / 2;
            }
            context.drawImage(overlay.image, 0, 0, overlay.image.width, overlay.image.height, x, y, overlay.image.width, overlay.image.height);
        });
        faviconElement.href = canvas.toDataURL();
    }
}
FaviconOverlayManager.canvas = null;
FaviconOverlayManager.faviconElement = null;
FaviconOverlayManager.faviconImage = null;
FaviconOverlayManager.overlays = [];
